import { render, staticRenderFns } from "./FundResultDetails.vue?vue&type=template&id=0927eeaa&scoped=true"
import script from "./FundResultDetails.vue?vue&type=script&lang=js"
export * from "./FundResultDetails.vue?vue&type=script&lang=js"
import style0 from "./FundResultDetails.vue?vue&type=style&index=0&id=0927eeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927eeaa",
  null
  
)

export default component.exports